/* ══ v14.4 (a): THE CONTINUOUS IMPROVEMENT PANE — the third portfolio view ═════════════════
   Every entry from every programme and project, grouped by CATEGORY — the field the outside
   fishbone process turns on. Read-only here: entries are written on a project's Governance
   page, and this pane offers no write controls, exactly like Activity. Reads straight from the
   merged __DB__ — nothing fetched, nothing computed at boot. */
function _ciAll() {
  const db = window.__DB__ || {};
  const progName = {};
  (Array.isArray(db.programmes) ? db.programmes : []).forEach(function (P) {
    if (P && P.id != null) progName[P.id] = P.name || 'Unnamed programme';
  });
  const rows = [];
  (Array.isArray(db.projects) ? db.projects : []).forEach(function (p) {
    if (!p) return;
    const list = ((p.appMeta || {}).improvements);
    if (!Array.isArray(list)) return;
    list.forEach(function (e) {
      if (!e || e.del) return;
      rows.push({ e: e, ref: _ciRegIdIn(list, e),
                  proj: p.name || '(unnamed project)',
                  prog: progName[p.programmeId] || '—' });
    });
  });
  return rows;
}
function _ciFiltered() {
  return _ciAll().filter(function (r) {
    if (_ciWho !== 'all' && (r.e.raisedBy || '') !== _ciWho) return false;
    if (_ciTypeF !== 'all' && r.e.type !== _ciTypeF) return false;
    if (_ciCat !== 'all' && ((r.e.category || '').trim() || '(uncategorised)') !== _ciCat) return false;
    if (_ciProg !== 'all' && r.prog !== _ciProg) return false;
    if (_ciProj !== 'all' && r.proj !== _ciProj) return false;
    return true;
  });
}
function _ciPaneOptions() {
  const people = {}, cats = {}, progs = {}, projs = {};
  _ciAll().forEach(function (r) {
    if (r.e.raisedBy) people[r.e.raisedBy] = 1;
    cats[(r.e.category || '').trim() || '(uncategorised)'] = 1;
    progs[r.prog] = 1;
    projs[r.proj] = 1;
  });
  const sortKeys = function (o) { return Object.keys(o).sort(function (a, b) { return a.localeCompare(b); }); };
  return { people: sortKeys(people), cats: sortKeys(cats), progs: sortKeys(progs), projs: sortKeys(projs) };
}
function setCiFilter(which, value) {
  if (which === 'who') _ciWho = value;
  else if (which === 'type') _ciTypeF = value;
  else if (which === 'cat') _ciCat = value;
  else if (which === 'prog') _ciProg = value;
  else if (which === 'proj') _ciProj = value;
  renderPortfolio();
}
function _ciGrouped(rows) {
  const groups = {};
  rows.forEach(function (r) {
    const k = (r.e.category || '').trim() || '(uncategorised)';
    (groups[k] = groups[k] || []).push(r);
  });
  const keys = Object.keys(groups).sort(function (a, b) {
    if (a === '(uncategorised)') return 1;
    if (b === '(uncategorised)') return -1;
    return a.localeCompare(b);
  });
  keys.forEach(function (k) {
    groups[k].sort(function (a, b) {
      return String(b.e.date || '').localeCompare(String(a.e.date || '')) || _mergeCmpKey(b.e.id, a.e.id);
    });
  });
  return { keys: keys, groups: groups };
}
function _ciPaneHtml() {
  const opts = _ciPaneOptions();
  const sel = function (id, which, cur, values, allLabel) {
    /* v15.2: a stored filter value that vanished from the options (its last entry renamed or
       deleted) kept FILTERING while the dropdown fell back to showing "All …" — an invisible
       filter and an inexplicable empty pane. The active value is always offered, so what is
       filtering is always what the control shows. */
    if (cur !== 'all' && values.indexOf(cur) === -1) values = values.concat([cur]);
    return `<select class="sort-select" id="${id}" onchange="setCiFilter('${which}',this.value)">` +
      `<option value="all"${cur === 'all' ? ' selected' : ''}>${allLabel}</option>` +
      values.map(function (v) {
        return `<option value="${_escapeHtml(v)}"${cur === v ? ' selected' : ''}>${_escapeHtml(v)}</option>`;
      }).join('') + `</select>`;
  };
  const bar = `<div class="act-bar">` +
    sel('ciWho', 'who', _ciWho, opts.people, 'Everyone') +
    `<select class="sort-select" id="ciType" onchange="setCiFilter('type',this.value)">` +
      `<option value="all"${_ciTypeF === 'all' ? ' selected' : ''}>All types</option>` +
      `<option value="improve"${_ciTypeF === 'improve' ? ' selected' : ''}>Needs improvement</option>` +
      `<option value="good"${_ciTypeF === 'good' ? ' selected' : ''}>Worked well</option>` +
    `</select>` +
    sel('ciCat', 'cat', _ciCat, opts.cats, 'All categories') +
    sel('ciProg', 'prog', _ciProg, opts.progs, 'All programmes') +
    sel('ciProj', 'proj', _ciProj, opts.projs, 'All projects') +
    `<span class="ci-spacer"></span>` +
    `<button class="ov-btn" onclick="copyImprovements(this)" title="Copy the entries below as plain text — the door out to your own analysis">Copy for analysis</button>` +
    `</div>`;
  const all = _ciFiltered();
  if (!all.length) {
    const anyAtAll = _ciAll().length;
    return bar + `<div class="act-empty">` +
      (anyAtAll
        ? `<b>Nothing matches these filters</b>Try widening them — every entry is still here.`
        : `<b>Nothing captured yet</b>Entries are written on a project's Governance page — its last section, below Minutes.<br>They all appear here, grouped by category.`) +
      `</div>`;
  }
  const g = _ciGrouped(all);
  let html = bar;
  g.keys.forEach(function (k) {
    const rows = g.groups[k];
    html += `<div class="ci-catbar"><b>${_escapeHtml(k)}</b><span>${rows.length} entr${rows.length === 1 ? 'y' : 'ies'}</span></div>`;
    html += rows.map(function (r) {
      const t = _ciTypeMeta(r.e.type);
      const nextLbl = (r.e.type === 'good') ? 'Keep doing:' : 'Next time:';
      /* the ◆6 idiom from Activity: programme and project drop off once a filter names them */
      const bits = [r.ref];
      if (_ciProg === 'all') bits.push(r.prog);
      if (_ciProj === 'all') bits.push(r.proj);
      if (r.e.raisedBy) bits.push(r.e.raisedBy);
      if (r.e.date) bits.push(formatDateDisplay(r.e.date));
      return `<div class="ci-prow"><span class="ci-pdot ${t[2]}" title="${_escapeHtml(t[1])}"></span>` +
        `<div class="ci-pbody">` +
        `<div class="ci-pline">${_escapeHtml(r.e.what || '(no description)')}</div>` +
        (r.e.better ? `<div class="ci-pnext"><b>${nextLbl}</b> ${_escapeHtml(r.e.better)}</div>` : ``) +
        `<div class="ci-pctx">${bits.map(_escapeHtml).join('<span class="ci-dot">·</span>')}</div>` +
        `</div></div>`;
    }).join('');
  });
  return html;
}
/* ◆5: the door out — the CURRENT FILTERED list as plain text, grouped exactly as shown.
   The copyAgenda clipboard idiom: button feedback on success, an honest alert on refusal. */
function copyImprovements(btn) {
  const all = _ciFiltered();
  if (!all.length) {
    if (btn) { const o = btn.textContent; btn.textContent = 'Nothing to copy'; setTimeout(function () { btn.textContent = o; }, 1600); }
    return;
  }
  const g = _ciGrouped(all);
  const lines = ['Continuous improvement — ' + all.length + ' entr' + (all.length === 1 ? 'y' : 'ies') +
                 ', copied ' + formatDateDisplay(_todayISO())];
  g.keys.forEach(function (k) {
    lines.push('');
    lines.push(k + ' (' + g.groups[k].length + ')');
    g.groups[k].forEach(function (r) {
      const t = _ciTypeMeta(r.e.type);
      const who = [r.ref, r.prog, r.proj];
      if (r.e.raisedBy) who.push(r.e.raisedBy);
      if (r.e.date) who.push(r.e.date);
      lines.push('- [' + t[1] + '] ' + who.join(' · '));
      lines.push('  What happened: ' + (r.e.what || '—'));
      if (r.e.better) lines.push('  Do differently: ' + r.e.better);
    });
  });
  navigator.clipboard.writeText(lines.join('\n')).then(function () {
    if (btn) { const o = btn.textContent; btn.textContent = 'Copied!'; setTimeout(function () { btn.textContent = o; }, 1500); }
  }).catch(function (err) {
    console.error('Copy for analysis failed:', err);
    alert('Could not copy the entries to the clipboard. Please copy manually.');
  });
}

